import type { PluginSidebarProps } from "@d12labs/plugins/types";
import {
	BrandSquare,
	SidebarBrand,
	SidebarNavItem,
	SidebarSection,
	SidebarSubItem,
} from "@d12labs/ui/sidebar-kit";
import { Library, Plus } from "lucide-react";
import { useWorkspaces } from "./hooks/use-kb";

/**
 * Contextual sidebar for the Knowledge Base plugin (the app shell renders this
 * when a `/kb` route is active). Workspace nav + a live "Recent workspaces"
 * list; the back chevron in the header returns to the app launcher. Reuses the
 * `useWorkspaces` query so the fetch is shared with the page.
 */
export const pluginSidebar = ({ onBack, onNavigate }: PluginSidebarProps) => {
	const { data: workspaces } = useWorkspaces();
	const recent = (workspaces ?? []).slice(0, 6);

	return (
		<div className="flex min-h-0 flex-1 flex-col overflow-y-auto">
			<SidebarBrand
				icon={<BrandSquare icon={Library} />}
				title="Knowledge Base"
				subtitle="Docs & grounded Q&A"
				onBack={onBack}
			/>
			<div className="flex flex-col gap-1 px-2 py-2">
				<SidebarSection label="Workspace">
					<SidebarNavItem
						to="/kb"
						exact
						icon={Library}
						label="Workspaces"
						onNavigate={onNavigate}
					/>
					<SidebarNavItem to="/kb" icon={Plus} label="New workspace" onNavigate={onNavigate} />
				</SidebarSection>

				{recent.length > 0 ? (
					<SidebarSection label="Recent workspaces">
						{recent.map((w) => (
							<SidebarSubItem
								key={w.id}
								to={`/kb/${w.id}`}
								label={w.name}
								onNavigate={onNavigate}
							/>
						))}
					</SidebarSection>
				) : null}
			</div>
		</div>
	);
};
